import React from "react";
import { useTranslation } from 'react-i18next';
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import ContactForm from "../sections/ContactForm";
import LocationSection from "../sections/LocationSection";
export default function ContactUs() {
    const { t } = useTranslation();
    UseScrollAnimation();
    return (
        <>
            <section className="contact-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div className="">
                        <div className="btmAni2000 font-bold text-white text-[40px] capitalize">{t("Get Closer to Us")}</div>
                    </div>
                </div>
            </section>

            <LocationSection/>

            <section className="relative py-[40px]">
                <div className="container">
                    <div className="w-100 flex mx-auto w-[75%] flex-col gap-[5px] items-center justify-center text-center">
                        <div className="js-scroll fade-top font-bold text-[25px] capitalize">{t("Get in Touch with Ligasos")}</div>
                        <p className="js-scroll fade-btm leading-[1.1]">
                            {t("Get in Touch with Ligasos Text")}
                        </p>
                    </div>
                </div>
            </section>

            <ContactForm/>
        </>
    );
}